import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AdminSessionService } from '../services/admin-session.service';
import { isAdminApiRequest, shouldUseMockApi } from '../utils/mock-api-routing.util';

/**
 * Attaches the AdminSessionService Bearer token to /admin/* API calls
 * that are routed to the real backend (not handled by the mock interceptor).
 */
export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isAdminApiRequest(req.url) || shouldUseMockApi(req.url)) {
    return next(req);
  }

  const adminSession = inject(AdminSessionService);
  const token = adminSession.getToken();

  if (!token) {
    return next(req);
  }

  const cloned = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
  return next(cloned);
};
